<style lang="less" rel="stylesheet/less">
/*隐藏播放器无用标签*/
.wcp-tooltip,
.wcp-subtitle-text,
.wcp-notif,
.wcp-status,
.wcp-titlebar,
.wcp-pause-anim,
.wcp-surface,
.wcp-menu,
.wcp-time-currentm,
.wcp-toolbar {
  position: fixed !important;
  left: 999999px !important;
  z-index: -1 !important;
  display: none !important;
  opacity: 0 !important;
}
.playvideo,
.playvideo_sub {
  width: 100%;
  height: 100%;
}
.playvideo_sub {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
#playvideocon {
  z-index: 2;
}
.wcp-center {
  width: 100% !important;
  height: 100% !important;
}
</style>
<template>
  <div class="playvideo">
    <div class="playvideo_sub" id="playvideocon"></div>
    <div class="playvideo_sub" id="playvideo"></div>
  </div>
</template>
<script>
import common from 'common';
import formatSeiMessage from '../../../js/seiUtils';
import { mapState, mapMutations } from 'vuex';

let wjsPath = '';
let wcjsPath = '';
let result = '';
let wjs = '';
let wcjs = '';
if (LIMI_ENV === 'electron') {
  //发布路径
  wjsPath = nodeProcess.cwd() + '/resources/app/assets/wcjs/wcjs-player';
  wcjsPath = nodeProcess.cwd() + '/resources/app/assets/wcjs/wcjs-prebuilt';
  result = nodeProcess.env.npm_lifecycle_event;
  //本地调试路径
  if (result === 'run:dev') {
    wjsPath = 'D:/project/ketang_live_pc/assets/wcjs/wcjs-player';
    wcjsPath = 'D:/project/ketang_live_pc/assets/wcjs/wcjs-prebuilt';
  }
  wjs = window.require(wjsPath);
  wcjs = window.require(wcjsPath);
}
export default {
  data() {
    return {
      player: null,
      test_use_sei: true,
      reconnectionNum: 0,
      uuids: [],
      cdnIP: '',
      videoLoadTimeoutInterval: null,
      waitingNumData: [],
    };
  },
  props: {
    aiSwitchVideoUrl: {
      default: false,
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.eventHub();
  },
  mounted() {
    setTimeout(this.setVLCvideo, 100);
    this.$root.eventHub.$emit('createLog', {
      id: 'LMTrackEventStreamChange',
      data: {
        unique_id: '',
        name: common.get('liveVideoUrlData').live_video_url_stream,
        url: common.get('liveVideoUrlData').live_video_url,
        cdnIP: this.cdnIP,
        reffer: '',
      },
    });
    //崩溃回调埋点记录
    wcjs.SetCrashCallBack((msg) => {
      let jsv = this.player.GetJsverison();
      let addv = this.player.GetAddOnverison();
      let vlcv = this.player.GetVlcDllverison();
      //
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventPlayerError',
        data: {
          client_type: common.device,
          player_version: 'jsv:' + jsv + '-addv:' + addv + '-vlcv:' + vlcv, //播放器版本号
          error: '播放器崩溃', //错误信息
        },
      });
    });
  },
  computed: {
    ...mapState([
      'liveVideoUrlData',
      'video_stream_load_timeout',
      'video_freeze_time',
      'video_freeze_last',
    ]),
  },
  methods: {
    ...mapMutations(['updateSeiTime']),
    //视频加载超时时间
    videoLoadTimeout() {
      clearTimeout(this.videoLoadTimeoutInterval);
      this.videoLoadTimeoutInterval = setTimeout(() => {
        this.destroyVideo();
        this.$emit('loaderr');
      }, this.video_stream_load_timeout * 1000);
    },
    formatSeiData(data) {
      try {
        let obj = JSON.parse(data.match(/\{[\S\s]+\}/)[0]);
        obj.ots = obj.ts;
        //添加题
        //console.log("12121",JSON.stringify(obj))
        let qa = obj.data.qa;
        if (qa.id != null) {
          Object.assign(qa, {
            seiType: 1,
            uid: obj.uid,
            lid: obj.lid,
            ots: obj.ts,
          });
        }

        //添加金币
        let coinArr = obj.data.coin;
        let resultArray = [];
        let coinInfo;
        for (let i = 0; i < coinArr.length; i++) {
          coinInfo = coinArr[i];
          resultArray.push(
            Object.assign(coinInfo, {
              seiType: 2,
              uid: obj.uid,
              lid: obj.lid,
              fts: obj.ts,
              ots: obj.ts,
            }),
          );
        }

        let badgeR = null;
        let questionR = null;
        let comment = null;
        let gameover = null;
        let giftSwitch = null;
        let pk = null;
        let switch_soe = null;
        let task = obj.data.task || [];
        task.forEach((item, index) => {
          if (item.type == 'comment') {
            comment = item;
            if (item.uuid != null) {
              Object.assign(comment, item, {
                seiType: 3,
                uid: obj.uid,
                lid: obj.lid,
                ots: obj.ts,
              });
            }
          }
          if (item.type == 'end_question') {
            gameover = item;
            if (item.uuid != null) {
              Object.assign(gameover, item, {
                seiType: 4,
                uid: obj.uid,
                lid: obj.lid,
                ots: obj.ts,
              });
            }
          }
          if (item.type == 'badge_ranking') {
            badgeR = item;
            if (item.uuid != null) {
              Object.assign(badgeR, item, {
                seiType: 5,
                uid: obj.uid,
                lid: obj.lid,
                ots: obj.ts,
              });
            }
          }
          if (item.type == 'question_ranking') {
            questionR = item;
            if (item.uuid != null) {
              Object.assign(questionR, {
                seiType: 6,
                uid: obj.uid,
                lid: obj.lid,
                ots: obj.ts,
              });
            }
          }
          if (item.type == 'giftSwitch') {
            giftSwitch = item;
            if (item.uuid != null) {
              Object.assign(giftSwitch, {
                seiType: 7,
                uid: obj.uid,
                lid: obj.lid,
                ots: obj.ts,
              });
            }
          }
          if (item.type === 'pk') {
            pk = item;
            if (item.uuid != null) {
              Object.assign(pk, {
                seiType: 8,
                uid: obj.uid,
                lid: obj.lid,
                ots: obj.ts,
              });
            }
          }
          if (item.type === 'switch_soe') {
            switch_soe = item;
            if (item.uuid != null) {
              Object.assign(switch_soe, {
                seiType: 9,
                uid: obj.uid,
                lid: obj.lid,
                ots: obj.ts,
              });
            }
          }
          if (item.type === 'camera_size') {
            this.$root.eventHub.$emit('cameraSize', item);
          }
        });

        if (qa && Object.keys(qa).length != 0) {
          formatSeiMessage(qa.seiType, qa, (datas) => {
            this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
          });
        }
        if (gameover && Object.keys(gameover).length != 0) {
          formatSeiMessage(gameover.seiType, gameover, (datas) => {
            this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
          });
        }
        if (comment && Object.keys(comment).length != 0) {
          formatSeiMessage(comment.seiType, comment, (datas) => {
            this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
          });
        }
        if (questionR && Object.keys(questionR).length != 0) {
          formatSeiMessage(questionR.seiType, questionR, (datas) => {
            this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
          });
        }

        if (badgeR && Object.keys(badgeR).length != 0) {
          formatSeiMessage(badgeR.seiType, badgeR, (datas) => {
            this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
          });
        }
        if (giftSwitch && Object.keys(giftSwitch).length != 0) {
          formatSeiMessage(giftSwitch.seiType, giftSwitch, (datas) => {
            this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
          });
        }
        if (pk && Object.keys(pk).length != 0) {
          formatSeiMessage(pk.seiType, pk, (datas) => {
            this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
          });
        }
        if (switch_soe && Object.keys(switch_soe).length != 0) {
          formatSeiMessage(switch_soe.seiType, switch_soe, (datas) => {
            this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
          });
        }

        if (resultArray && resultArray.length != 0) {
          for (let item of resultArray) {
            formatSeiMessage(item.seiType, item, (datas, flag) => {
              if (flag) {
                //按选项加金币判断请求服务器验证
                if (!this.uuids.includes(datas.unique_id)) {
                  this.$root.eventHub.$emit('partCoin', datas.unique_id);
                  this.uuids.unshift(datas.unique_id);
                  this.uuids.length = 30;
                }
                return;
              }
              this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
            });
          }
        }
        formatSeiMessage(0, obj, (datas) => {
          this.$root.eventHub.$emit('seiMessage', JSON.stringify(datas));
        });
      } catch (error) {}
    },
    eventHub() {
      this.offEventHub();
      this.$root.eventHub.$on('restartVideo', () => {
        this.reconnection();
      });
      this.$root.eventHub.$on('destroyVideo', () => {
        this.destroyVideo();
      });
      this.$root.eventHub.$on('test_use_sei', (flag) => {
        this.test_use_sei = flag;
      });
      this.$root.eventHub.$on('videoMuted', (muted) => {
        this.player && this.player.mute(muted);
      });
    },
    offEventHub() {
      this.$root.eventHub.$off('restartVideo');
      this.$root.eventHub.$off('destroyVideo');
      this.$root.eventHub.$off('test_use_sei');
      this.$root.eventHub.$off('videoMuted');
    },
    waitingNum() {
      if (!this.aiSwitchVideoUrl) {
        this.waitingNumData = [];
        return;
      }
      this.waitingNumData.unshift(Date.now());
      this.waitingNumData.length = this.video_freeze_time;
      let lastTime = this.waitingNumData[0];
      let firstTime = this.waitingNumData[this.video_freeze_time - 1] || 0;
      if (lastTime - firstTime < this.video_freeze_last * 1000) {
        this.waitingNumData = [];
        this.$emit('autoSwitchVideoUrl');
      }
      // console.log(this.waitingNumData)
    },
    destroyVideo() {
      if (this.player) {
        this.player.clearPlaylist();
        this.player.stop();
        this.player.close();
        this.player = null;
        let dom = document.querySelector('#playvideocon');
        if (dom) dom.innerHTML = '';
      }
    },
    setVLCvideo() {
      if (
        this.$route.name !== 'video' ||
        !document.querySelector('#playvideocon')
      )
        return;
      this.destroyVideo();
      let uri = this.liveVideoUrlData.live_video_url;
      common.set('live_video_url_now', uri);
      if (!uri) {
        this.$emit('loaderr');
        return;
      }
      this.$emit('tip', true);
      this.videoLoadTimeout();
      //新版本
      let player = new wjs().addPlayer({
        id: 'playvideocon',
        autoplay: false,
        wcjs: wcjs,
      });
      player.addPlaylist(uri);
      player.play();
      // player.onBuffering(percent => {
      //   //
      // });
      player.onState((status) => {
        if (status == 'playing') {
          this.reconnectionNum = 0;
          clearTimeout(this.videoLoadTimeoutInterval);
          setTimeout(() => {
            this.$emit('tip', false);
          }, 100);
        }
        if (status === 'error') {
          let jsv = this.player.GetJsverison();
          let addv = this.player.GetAddOnverison();
          let vlcv = this.player.GetVlcDllverison();
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventPlayerError',
            data: {
              client_type: common.device,
              player_version: 'jsv:' + jsv + '-addv:' + addv + '-vlcv:' + vlcv, //播放器版本号
              error: '播放器异常', //错误信息
            },
          });
          this.videoError();
        }
        if (status === 'buffering') {
          this.$emit('tip', true);
        }
        // if(status==="stopping"){
        //   this.waitingNum();
        // }
      });
      player.setSeiCallback((message) => {
        if (this.test_use_sei === false) {
          //
          return;
        }
        //sei信息回调接口
        if (sessionStorage.getItem('breakSEI') == 2) return;
        this.updateSeiTime(Date.now());
        this.formatSeiData(message);
      });
      player.setStreamDryCallback(() => {
        this.$emit('tip', true);
        //断流回调函数
        //
        this.$root.eventHub.$emit('createLog', {
          id: 'LMTrackEventStreamLose',
          data: {
            url: this.liveVideoUrlData.live_video_url,
            cdnIP: this.cdnIP,
          },
        });
      });
      // player.setLogCallback((level, message, format) => {
      //   //播放器日志回调
      //   if (level == 4) {
      //
      //   }
      // });
      player.setNetSlowCallback((flag) => {
        if (flag) {
          this.$emit('tip', true);
          this.waitingNum();

          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventStreamCaton',
            data: {
              url: this.liveVideoUrlData.live_video_url,
              cdnIP: this.cdnIP,
            },
          });
          return;
        }
        if (!flag) {
          this.$emit('tip', false);
          //
        }
      });
      //cdn ip
      player.setIpInfoCallback((level, message, format) => {
        this.cdnIP = message;
      });
      player.setIpInfoCallback((level, message, format) => {
        this.cdnIP = message;
      });
      //下载速度
      let speedCallbackNum = 0; //用于判断时间，五秒回调一次，十秒记录一次下载速率
      player.setSpeedCallback((level, message, format) => {
        this.$emit('videoSpeed', message / 1000);
        if (speedCallbackNum >= 11) {
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventLiveStreamInfo',
            data: {
              bitRate: message / 1000,
              liveServer: this.cdnIP, //
              clientIP: common.WANIP, //客户端ip
            },
          });
          speedCallbackNum = 0;
          return;
        }
        speedCallbackNum++;
        //
      });
      this.player = player;
    },
    videoError() {
      this.reconnectionNum++;
      if (this.reconnectionNum >= 3) {
        clearTimeout(this.videoLoadTimeoutInterval);
        this.$emit('loaderr');
        this.$root.eventHub.$emit('createLog', {
          id: 'LMTrackEventStreamLose',
          data: {
            url: this.liveVideoUrlData.live_video_url,
            cdnIP: this.cdnIP,
          },
        });
        this.reconnectionNum = 0;
        this.destroyVideo();
        return;
      }
      this.$emit('tip', true);
      this.reconnection();
    },
    reconnection() {
      this.setVLCvideo();
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventPlayerRestart',
      });
    },
  },
  beforeDestroy() {
    this.destroyVideo();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness/video/vlcplayer.vue